<template>
  <FormField v-slot="$field" :name="name" :resolver="resolver" :class="formFieldClass">
    <InputGroup v-if="withAddon">
      <template v-if="addonPosition === 'left'">
        <InputGroupAddon v-if="$slots.addon" :class="addonClass"><slot name="addon" /></InputGroupAddon>
        <InputGroupAddon v-else-if="addonValue" :class="addonClass">{{ addonValue }}</InputGroupAddon>
      </template>

      <FloatLabel variant="on" :class="floatLabelClass">
        <slot v-bind="$field" />
        <label :for="id">{{ label }} <span v-if="required" class="text-red-500">*</span></label>
      </FloatLabel>

      <template v-if="addonPosition === 'right'">
        <InputGroupAddon v-if="$slots.addon" :class="addonClass"><slot name="addon" /></InputGroupAddon>
        <InputGroupAddon v-else-if="addonValue" :class="addonClass">{{ addonValue }}</InputGroupAddon>
      </template>
    </InputGroup>

    <FloatLabel v-else variant="on" :class="floatLabelClass">
      <slot v-bind="$field" />
      <label :for="id">{{ label }} <span v-if="required" class="text-red-500">*</span></label>
    </FloatLabel>

    <template v-if="$field?.error?.message || validationErrors?.[name]?.length">
      <Message severity="error" size="small" variant="simple">
        <template v-if="$field?.error?.message">
          <p>{{ $field.error.message }}</p>
        </template>

        <template v-if="validationErrors?.[name]?.length">
          <p v-for="(message, index) in validationErrors[name]" :key="index">{{ message }}</p>
        </template>
      </Message>
    </template>
  </FormField>
</template>

<script setup>
/* global defineProps */
import { FormField } from '@primevue/forms'
import { FloatLabel, InputGroup, InputGroupAddon } from 'primevue'

defineProps({
  name: { type: String, required: true },
  resolver: { type: Function, default: null },
  id: { type: String, required: true },
  label: { type: String, default: '' },
  required: { type: Boolean, default: false },
  validationErrors: { type: Object, default: () => ({}) },
  withAddon: { type: Boolean, default: false },
  addonValue: { type: String, default: '' },
  addonClass: { type: String, default: '' },
  addonPosition: { type: String, default: 'left', validator: (v) => ['left', 'right'].includes(v) },
  formFieldClass: { type: String, default: 'flex flex-col w-full' },
  floatLabelClass: { type: String, default: '' },
})
</script>
